module.exports = __webpack_public_path__ + "static/media/sprite_sprite.fceb20df.svg";